import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useStore, useToast, useResource, useModal, usePage, useOptions } from "@/comn/hooks";
import { URLS, APIS, SF_INTF_ORG_ENPO_INFO } from "./services/OsciIntfOrgEnpoMgmtService";

/*
 * Organization Endpoint
 * !== 기관 Endpoint 등록 ==!
 */
export const OSCI0113005S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const [sndrcvDvnCd, setSndrcvDvnCd] = useState();
    const [trgtTpCd, setTrgtTpCd] = useState();
    const [govesbUseYn, setGovesbUseYn] = useState<boolean>(false);
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0103" }, // 대상 유형 코드
            { area: "comnCd", comnCd: "OSC0110" }, // 채널 신청 진행상태 코드
            { area: "comnCd", comnCd: "OSC0101" }, // 활성화 여부 코드
            { area: "comnCd", comnCd: "OSC0109" }, // 송수신 구분 코드
            { area: "comnCd", comnCd: "OSC0105" }, // 연계 프로토콜 코드
            { area: "comnCd", comnCd: "OSC0104" }, // 송수신 유형 코드
            { area: "comnCd", comnCd: "OSC0112" }, // 연계인증 유형 코드
            { area: "orgCd" }, // 조직 코드 (등록된 조직 검증용)
        ],
    });
    const { options: orgCdOptions } = useOptions({ area: "orgCd" });
    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        intfOrgEnpoForm: useForm({
            defaultSchema: SF_INTF_ORG_ENPO_INFO,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Create Channel !== 채널 등록 ==!
        insertIntfOrgEnpo: useFetch({
            api: (data) => APIS.insertIntfOrgEnpo({ ...data }),
            onSuccess: (res) => {
                modal.openModal({
                    content: "msg.osc.00073", // Successfully saved., !== 정상적으로 저장되었습니다. ==!
                    onConfirm: () => {
                        const orgEnpoId = res.intfOrgEnpo.content.orgEnpoId;

                        navigate(`${URLS.osci0113006s}/${orgEnpoId}`);
                    },
                    close: false,
                });
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    form.intfOrgEnpoForm.setErrors(error.response.data.errors);
                }

                const { errorCode, errorMessage } = error.response.data;

                if (errorCode === "-999") {
                    modal.openModal({
                        content: errorMessage,
                    });

                    return;
                }

                modal.openModal({
                    content: "msg.osc.00015", // An error occurred during processing.
                });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // on Save Button Click Event Handler  !== 등록 버튼 클릭 ==!
        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.intfOrgEnpoForm.errors)) {
                toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }
            form.intfOrgEnpoForm.handleSubmit(
                () => {
                    const data = form.intfOrgEnpoForm.getValues();

                    modal.openModal({
                        content: "msg.osc.00090", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.insertIntfOrgEnpo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
        // Form readOnly processing according to transmission and reception classification !== 송수신 구분에 따른 form readOnly 처리 ==!
        onChangetrgtTpCd: (isNull: boolean) => {},
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {}, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"L_ORG_ENPO_INFO"} titleSize={2}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.intfOrgEnpoForm.schema.sndrcvDvnCd}
                                onChange={(value) => {
                                    form.intfOrgEnpoForm.clearErrors();

                                    if (comnUtils.isEmpty(sndrcvDvnCd)) {
                                        setSndrcvDvnCd(value);
                                    } else if (sndrcvDvnCd !== value) {
                                        modal.openModal({
                                            // All entered information will be reset. Do you want to change it?. !== 입력한 정보가 모두 초기화됩니다. 변경하시겠습니까?. ==!
                                            content: "msg.osc.00117",
                                            onConfirm: () => {
                                                form.intfOrgEnpoForm.reset();

                                                form.intfOrgEnpoForm.setValue("sndrcvDvnCd", value);
                                                setSndrcvDvnCd(value);
                                            },
                                            onCancel: () => {
                                                form.intfOrgEnpoForm.setValue("sndrcvDvnCd", sndrcvDvnCd);
                                                setSndrcvDvnCd(sndrcvDvnCd);
                                            },
                                        });
                                    }
                                }}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.orgEnpoId} />
                            <Group.Control {...form.intfOrgEnpoForm.schema.orgEnpoNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.intfOrgEnpoForm.schema.orgCd}
                                validate={(value: any) =>
                                    !value ||
                                    value === "TANCIS" ||
                                    orgCdOptions.some((option) => option.value === value) ||
                                    "msg.osc.00003"
                                }
                            />
                            {/* <Group.Control {...form.intfOrgEnpoForm.schema.orgTin} /> */}
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.orgIpAddr} />
                            <Group.Control {...form.intfOrgEnpoForm.schema.orgPortNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.orgUrlAddr} controlSize={10} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"T_IFAUTH_INFO"} titleSize={2}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.intfOrgEnpoForm.schema.govesbUseYn}
                                onChange={(value) => {
                                    setGovesbUseYn(value == "Y");
                                }}
                            />
                        </Group.Row>
                        {govesbUseYn && (
                            <Group.Row>
                                <Group.Control {...form.intfOrgEnpoForm.schema.apiCd} />
                                <Group.Control {...form.intfOrgEnpoForm.schema.pushCd} />
                            </Group.Row>
                        )}
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.tknTpCd} />
                            <Group.Control {...form.intfOrgEnpoForm.schema.tknUrlAddr} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.tknId} />
                            <Group.Control {...form.intfOrgEnpoForm.schema.tknPwd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.tknCn} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.signFileId} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.signKeyCn} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.rspnSignFileId} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.rspnSignKeyCn} controlSize={10} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.osci0113004q);
                        }}
                    />
                </Layout.Left>
                <Layout.Right>
                    <Button
                        role="save"
                        onClick={() => {
                            handler.onSaveBtnClick();
                        }}
                    ></Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};
